import {
  Stack,
  useMediaQuery,
  Dialog,
  useTheme,
  Slide,
  Typography,
  Button,
} from '@mui/material';
import FolderCard from '../common/FolderCard';
import React, { useState } from 'react';
import translations from 'utils/translations';
import { useIntl } from 'react-intl';
import {
  BackButton,
  RedLinkButton,
  ViewFoldersDialogContent,
} from '../common/styles';
import ClearIcon from '@mui/icons-material/Clear';
import {
  useBookmarkSelector,
  useBookmarkStore,
} from 'pages/exhibitor/exhibitorBookmarks';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const Folders = ({
  onCreateNewFolder,
  onDeleteFolderClick,
  onEditFolderClick,
}) => {
  const theme = useTheme();
  const is1024Down = useMediaQuery(theme.breakpoints.down(1024));
  const isLgUp = useMediaQuery(theme.breakpoints.up('lg'));
  const intl = useIntl();
  const i18n = translations.ExhibitorsV2(intl);
  const {
    folders: storeFolders,
    currentFolderOnView,
    isEditing,
  } = useBookmarkSelector();

  //States
  const [isFoldersDialogOpen, setIsFoldersDialogOpen] = useState(false);

  const openFolders = () => {
    handleClickOpen();
  };

  const handleClickOpen = () => {
    setIsFoldersDialogOpen(true);
  };

  const handleClose = () => {
    setIsFoldersDialogOpen(false);
  };

  return (
    <Stack
      gap={'25px'}
      padding={isLgUp ? '20px' : is1024Down ? '0' : '30px 20px'}
      width={'100%'}
      maxWidth={is1024Down ? '100%' : '354px'}
      sx={{
        ...(is1024Down && {
          margin: '0 auto',
        }),
      }}
    >
      <Stack
        flexDirection={'row'}
        gap={'30px'}
        justifyContent={is1024Down ? 'space-between' : 'flex-start'}
      >
        {currentFolderOnView?.folderId ? (
          <BackButton
            backFn={() =>
              useBookmarkStore.setState({ currentFolderOnView: null })
            }
            backMsg={i18n.PersonalPage.backAllFolders}
          />
        ) : (
          <Typography variant="body1-bold">
            {' '}
            {`${i18n.PersonalPage.folderCard.listTitle1} ${
              storeFolders?.length
            } ${
              storeFolders?.length === 1
                ? i18n.PersonalPage.folderCard.listTitle2sing
                : i18n.PersonalPage.folderCard.listTitle2plur
            }`}
          </Typography>
        )}

        {is1024Down && (
          <RedLinkButton
            msg={i18n.PersonalPage.viewFolders}
            variant="link1"
            onClick={() => openFolders()}
          />
        )}
      </Stack>
      {!is1024Down ? (
        <>
          {currentFolderOnView?.folderId ? (
            <>
              <div>
                <Typography variant="body1">
                  {i18n.PersonalPage.folder}
                </Typography>
                <Typography variant="body1-bold">
                  {currentFolderOnView.name}
                </Typography>
              </div>
              {isEditing ? (
                <>
                  <RedLinkButton
                    leftIcon={
                      <ModeEditOutlineOutlinedIcon
                        fontSize="small"
                        htmlColor={theme.palette.primary.main}
                      />
                    }
                    variant="link1"
                    onClick={() => onEditFolderClick(currentFolderOnView)}
                    msg={i18n.PersonalPage.editName}
                    customStyle={{ justifyContent: 'flex-start' }}
                  />
                  <RedLinkButton
                    leftIcon={
                      <DeleteOutlineOutlinedIcon
                        fontSize="small"
                        htmlColor={theme.palette.primary.main}
                      />
                    }
                    variant="link1"
                    onClick={() => onDeleteFolderClick(currentFolderOnView)}
                    msg={i18n.PersonalPage.deleteFolder}
                    customStyle={{ justifyContent: 'flex-start' }}
                  />
                </>
              ) : null}
            </>
          ) : (
            <>
              {storeFolders?.map((i, idx) => (
                <FolderCard
                  key={idx}
                  folder={i}
                  onDelete={onDeleteFolderClick}
                  onEdit={onEditFolderClick}
                  mobileFolderClicked={() => {}}
                />
              ))}
            </>
          )}
        </>
      ) : null}
      {!is1024Down && !currentFolderOnView?.folderId ? (
        <Button
          variant={'contained'}
          color="primary"
          onClick={onCreateNewFolder}
          size="s"
        >
          {i18n.PersonalPage.createNewFolder}
        </Button>
      ) : null}
      <Dialog
        fullScreen
        open={isFoldersDialogOpen}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <ViewFoldersDialogContent>
          <Stack flexDirection={'row'} justifyContent={'space-between'}>
            <Typography variant="l">{i18n.PersonalPage.folders}</Typography>
            <ClearIcon onClick={handleClose} />
          </Stack>
          {storeFolders?.map((i, idx) => (
            <FolderCard
              key={idx}
              folder={i}
              onDelete={onDeleteFolderClick}
              onEdit={onEditFolderClick}
              mobileFolderClicked={() => handleClose()}
            />
          ))}
          <Button
            variant={'contained'}
            color="primary"
            onClick={onCreateNewFolder}
            size="s"
          >
            {i18n.PersonalPage.createNewFolder}
          </Button>
        </ViewFoldersDialogContent>
      </Dialog>
    </Stack>
  );
};
export default Folders;
